module.exports = __webpack_public_path__ + "static/media/color_bed.cb8a85e1.svg";